import React from 'react';
import NewOpportunityDetailsContainer from './NewOpportunityDetailsContainer';

export const NewOpportunityContianer = props => <NewOpportunityDetailsContainer {...props} />;

export default NewOpportunityContianer;
